'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _colors = require('../settings/colors');

var _colors2 = _interopRequireDefault(_colors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  profileCard: {
    backgroundColor: _colors2.default.theme,
    color: _colors2.default.white,
    fontSize: '20px',
    fontWeight: 'bolder',
    lineHeight: '20px',
    padding: '16px'
  },
  withAvatar: {
    lineHeight: '40px',
    overflow: 'auto'
  },
  username: {
    margin: '0',
    maxWidth: 'calc(100% - 101px)',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    display: 'inline-block',
    color: _colors2.default.white,
    fontWeight: 'inherit'
  },
  avatar: {
    float: 'left',
    width: '80px',
    height: '80px',
    border: '2px solid ' + _colors2.default.white,
    marginRight: '15px',
    boxSizing: 'border-box'
  }
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/anchor-ui/profile-card/styles.js
// module id = 348
// module chunks = 0